module.exports = __webpack_public_path__ + "img/IMG_9022_L.a063fcbb.webp";